export default __webpack_public_path__ + "static/media/cards.f993f7de.png";